<template>
  <v-form @submit.prevent="$emit('save', contact)">
    <v-card>
      <v-card-title>
        {{ $t('edit_contact') }}
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="contact.first_name"
              :error-messages="errors['first_name']"
              :label="formMixin_getRequiredFieldLabel($t('first_name'))"
              name="first_name"
              autofocus
              @input="formMixin_clearErrors('first_name')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              v-model="contact.last_name"
              :error-messages="errors['last_name']"
              :label="formMixin_getRequiredFieldLabel($t('last_name'))"
              name="last_name"
              @input="formMixin_clearErrors('last_name')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              v-model="contact.email"
              :error-messages="errors['email']"
              :label="$t('email')"
              name="email"
              @input="formMixin_clearErrors('email')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              v-model="contact.phone"
              :error-messages="errors['phone']"
              :label="$t('phone')"
              name="phone"
              @input="formMixin_clearErrors('phone')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="contact.is_published"
              :error-messages="errors['is_published']"
              :label="$t('published')"
              @change="formMixin_clearErrors('is_published')"
            />
          </v-col>
        </v-row>

        <template v-if="!contact.image">
          <BaseFileDropZone
            accept=".jpeg,.jpg,.bmp,.png,.gif"
            @drop="onImageUpload($event, 'image', 'App\\Models\\Contact', contact.id)"
          >
            <div
              class="drop-zone"
              :class="errors.hasOwnProperty('images.0') ? 'error-outline' : ''"
            >
              <div class="drop-zone-message">
                <p>{{ $t('file_drop_zone_message') }}</p>
              </div>
            </div>
          </BaseFileDropZone>
          <!-- we don't clear error, because we don't know image index.
          Instead error will not be visible once we upload the file -->
          <template v-for="(value, key) in errors">
            <div v-if="key.includes('images')" :key="key">
              <div
                v-for="(error, errorIndex) in value"
                :key="errorIndex"
                class="mt-2 v-messages theme--light error--text"
              >
                {{ error }}
              </div>
            </div>
          </template>
        </template>

        <div v-else class="pl-10">
          <v-img
            v-if="contact.image"
            :src="$backendUrl(contact.image.image_path)"
            :alt="contact.image.original_name"
            width="100px"
            height="100px"
            class="patient-story-img"
          />
          <div class="d-flex justify-space-between name-box">
            <p class="image-name text-truncate" v-if="contact.image">
              {{ contact.image.original_name }}
            </p>
            <v-btn icon @click="onImageDelete(contact.image)"><v-icon>mdi-delete</v-icon></v-btn>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <span class="text-subtitle-2 ml-3">
          *
          {{ $t('must_be_filled') }}
        </span>

        <v-spacer />

        <v-btn text color="secondary" @click="$emit('preview', contact)">{{ $t('preview') }}</v-btn>

        <v-btn text color="primary" @click="$emit('cancel')">
          {{ $t('cancel') }}
        </v-btn>

        <v-btn :disabled="disabled" :loading="disabled" color="primary" text type="submit">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import formMixin from '../mixins/form-mixin';
import BaseFileDropZone from './base/BaseFileDropZone';

export default {
  name: 'ContactForm',

  components: { BaseFileDropZone },

  mixins: [formMixin],

  props: {
    contact: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onImageUpload(image, type, modelType, modelId) {
      this.$emit('upload:image', image, type, modelType, modelId);
    },

    onImageDelete(image) {
      this.$emit('delete:image', image);
    },
  },
};
</script>

<style scoped>
.drop-zone {
  background-color: white;
  outline: 2px dashed darkgray;
  width: 97%;
  height: 100px;
  text-align: center;
  margin: auto;
  position: relative;
}
.drop-zone-message {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.drop-zone-message p,
.image-name {
  color: darkgray;
  margin: 0;
}
.name-box {
  width: 120px;
}
</style>
